import { nonUndefined } from "Utility";
import {
  FsTimeAttackRoundSpan,
  mapTimeAttackRoundSpan,
} from "./Span/FsTimeAttackRoundSpan";
import {
  TimeAttackRound,
  TimeAttackTimes,
} from "model/Match/Set/TimeAttack/Track/Round/TimeAttackRound";
import { RoundSpan } from "model/Match/Set/TimeAttack/Track/Round/Span/RoundSpan";

type FsTimeAttackTime = {
  [driverId: string]: number | undefined;
};

export type FsTimeAttackRound = {
  name: string | undefined;
  span: FsTimeAttackRoundSpan | undefined;
  times: FsTimeAttackTime | undefined;
};

export const mapTimeAttackRounds = (
  fsModels: FsTimeAttackRound[]
): TimeAttackRound[] => {
  return nonUndefined(fsModels.map(mapRound));
};

const mapRound = (fsModel: FsTimeAttackRound): TimeAttackRound | undefined => {
  const span: RoundSpan | undefined = !!fsModel.span
    ? mapTimeAttackRoundSpan(fsModel.span)
    : { numRuns: 1 };

  if (!span) {
    return undefined;
  }

  return {
    name: fsModel.name,
    span,
    times: mapTimes(fsModel.times ?? {}),
  };
};

const mapTimes = (fsTimes: FsTimeAttackTime) => {
  const keys = Object.keys(fsTimes);
  const times: TimeAttackTimes = {};
  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    const fsTime = fsTimes[key];
    if (!!fsTime) {
      times[key] = fsTime;
    }
  }

  return times;
};
